import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Language, Utils } from "../../../utils";
import { Button, ErrorIcon } from "../../../components";

import Grid from "@material-ui/core/Grid";

import makeClasses from "../styles";

import clsx from "clsx";
import { InputLabel, TextField } from "@material-ui/core";

const StepTwo = ({ history, nextStep, handleChange, code }) => {
  const classes = makeClasses();

  const { loading, languageTexts } = useSelector((state) => ({
    loading: state.user.loading,
    languageTexts: state.language.texts || {},
  }));

  const i18n = Language(languageTexts);

  const [inputEmail, setInputEmail] = useState("");
  const [inputEmailConfirmation, setInputEmailConfirmation] = useState("");
  const [hasEmailFormatError, setHasEmailFormatError] = useState(false);
  const [hasEmailMismatchError, setHasEmailMismatchError] = useState(false);

  const canMoveToNext =
    inputEmail.trim().length > 0 &&
    inputEmailConfirmation.trim().length > 0 &&
    !hasEmailFormatError &&
    !hasEmailMismatchError &&
    inputEmail === inputEmailConfirmation;

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setInputEmail(value);
    setHasEmailFormatError(
      value.length > 0 && !Utils.inputs.email.regex.test(value.trim()),
    );
    setHasEmailMismatchError(
      inputEmailConfirmation.length > 0 &&
        value.trim() !== inputEmailConfirmation.trim(),
    );
  };

  const handleEmailConfirmationChange = (e) => {
    const value = e.target.value;
    setInputEmailConfirmation(value);
    setHasEmailMismatchError(value.trim() !== inputEmail.trim());
  };

  const handleNext = () => {
    const email = inputEmail.trim();
    const emailConfirmation = inputEmailConfirmation.trim();

    if (!Utils.inputs.email.regex.test(email)) {
      setHasEmailFormatError(true);
      return;
    }

    if (email !== emailConfirmation) {
      setHasEmailMismatchError(true);
      return;
    }

    nextStep({ email: email });
  };

  return (
    <React.Fragment>
      <div className={classes.formContent}>
        <div className={classes.formTitleContainer}>
          <div className={classes.formTitle}>
            {i18n.get("LegalEntityRegistration.StepFormTitle")}
          </div>
          <div className={classes.formText}>
            {i18n.get("LegalEntityRegistration.Step2FormText")}
          </div>
        </div>
        <form layout="vertical" onSubmit={handleNext} className={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputLabel className={classes.formLabel}>
                {i18n.get("LegalEntityRegistration.InputEmailLabel")}
              </InputLabel>
              <TextField
                error={hasEmailFormatError}
                placeholder={i18n.get(
                  "LegalEntityRegistration.InputEmailTitle",
                )}
                className={classes.formInput}
                onChange={handleEmailChange}
                classes={{ root: classes.formInput }}
                variant="outlined"
                value={inputEmail}
                inputProps={{
                  autoComplete: "off",
                  onCopy: (e) => e.preventDefault(),
                  onPaste: (e) => e.preventDefault(),
                }}
              />
              {hasEmailFormatError && (
                <div className={classes.errorMessageContainer}>
                  <ErrorIcon />
                  <div className={classes.errorMessage}>
                    {i18n.get("LegalEntityRegistration.InputEmailError")}
                  </div>
                </div>
              )}
            </Grid>
            <Grid item xs={12}>
              <InputLabel className={classes.formLabel}>
                {i18n.get(
                  "LegalEntityRegistration.InputEmailConfirmationLabel",
                )}
              </InputLabel>
              <TextField
                error={hasEmailMismatchError}
                placeholder={i18n.get(
                  "LegalEntityRegistration.InputEmailTitle",
                )}
                className={classes.formInput}
                onChange={handleEmailConfirmationChange}
                classes={{ root: classes.formInput }}
                variant="outlined"
                value={inputEmailConfirmation}
                inputProps={{
                  autoComplete: "off",
                  onCopy: (e) => e.preventDefault(),
                  onPaste: (e) => e.preventDefault(),
                }}
              />
              {hasEmailMismatchError && (
                <div className={classes.errorMessageContainer}>
                  <ErrorIcon />
                  <div className={classes.errorMessage}>
                    {i18n.get("LegalEntityRegistration.InputEmailConfirmationError")}
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </form>
      </div>
      <div className={classes.termsWrapper}>
        <div
          className={clsx(
            classes.formSubmitContainer,
            classes.formSubmitContainerWithOneButton,
            classes.formSubmitContainerWithNoMargin,
          )}>
          <Button
            className={classes.formSubmitButton}
            disabled={loading || !canMoveToNext}
            onClick={handleNext}>
            {i18n.get("LegalEntityRegistration.NextButton")}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};
StepTwo.id = "com.Handy.LegalEntityRegistration.StepTwo";
export default StepTwo;
